import { render } from "./CompositeStockForm.vue?vue&type=template&id=103e7b34"
import script from "./CompositeStockForm.vue?vue&type=script&lang=ts"
export * from "./CompositeStockForm.vue?vue&type=script&lang=ts"
script.render = render

export default script